import { PostBoxSvg } from "./images/PostBoxSvg";

import { Alert } from "./Alert";

import styles from "./Form.module.css";


const className = process.env.APP === "sb" ? styles.themeSb : styles.themeSmd

export const Form = ({ onSubmit, status, isLoading }) => {


  return (
    <form onSubmit={onSubmit} className={`${styles.form} ${className}`}>
      <PostBoxSvg loaded={!!status} />
      <div className={styles.formContent}>
        <h3 className={styles.heading}>
          Узнавайте первыми о полезных материалах
        </h3>
        <div className={styles.subscribe}>
          <input
            name="email"
            required
            placeholder="email"
            className={styles.email}
            type="email"
          />
          <button disabled={isLoading} className={styles.button}>Подписаться</button>
        </div>
        {isLoading && <div className={styles.loading}><p>Загрузка....</p></div>}
        {status && <Alert type={status} />}
        <div>
          <input
            required
            checked
            className={styles.hidden}
            type="checkbox"
            id="agreement"
          />
          <label className={styles.checkboxLabel} htmlFor="agreement">
            <span className={styles.checkbox}>
              <svg
                width="13"
                height="9"
                viewBox="0 0 13 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.87108 6.6192L11.0611 0.428467L12.014 1.38068L4.87108 8.52362L0.585449 4.23799L1.53766 3.28578L4.87108 6.6192Z"
                  fill="var(--mail-box-text-color)"
                />
              </svg>
            </span>{" "}
            <p>
              Соглашаюсь на передачу <a href={process.env.AGREEMENT_LINK} target="_blank" rel="noreferrer">персональных данных</a> и
              получение индивидуальных предложений
            </p>
          </label>
        </div>
      </div>
    </form>
  );
};
